
import authenticated from "../middleware/authenticated";
import connectToWebsocket from "../middleware/connectToWebsocket";
import Conversation from "../../components/chat/Conversation";
import Friends from "../../components/chat/Friends";
import Messages from "../../components/chat/Messages";
import AddFriend from "../../components/chat/AddFriend";

export default [
    {
        path: '/chat/:id',
        component: Conversation,
        name: 'chat-conversation',
        props: route => {
            return {
                chatId: route.params.id
            }
        },
        meta: {
            hasNavigation: false,
            middleware: [
                authenticated,
                connectToWebsocket
            ]
        }
    },
    {
        path: '/friends',
        component: Friends,
        name: 'chat-friends',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },
    {
        path: '/chat',
        component: Messages,
        name: 'chat-messages',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },
    {
        path: '/add-friend',
        component: AddFriend,
        name: 'add-friend',
        meta: {
            hasNavigation: true,
            middleware: [
                authenticated
            ]
        }
    },
];